import http from '@/services/http';
import { quarantineFilters } from '@/config';
import { LAB_SAMPLE_STATUSES } from '@/config/constants';
import tableHelper from '@/services/tableHelper';

const quarantine = {
  index(tableFilters, filterStatus, config = {}) {
    const filters = tableHelper.whereFilters(filterStatus, quarantineFilters);
    return http.request({
      method: 'get',
      url: '/quarantined-samples',
      params: { filter: { ...tableFilters, where: filters } },
      ...config,
    });
  },
  count(filterStatus, config = {}) {
    const where = tableHelper.whereFilters(filterStatus, quarantineFilters);
    return http.request({
      method: 'get',
      url: '/quarantined-samples/count',
      params: { where },
      ...config,
    });
  },
  show(sampleId) {
    return http.request({
      method: 'get',
      url: `/quarantined-samples/${sampleId}`,
    });
  },
  create(labSampleId, data) {
    return http.request({
      method: 'post',
      url: '/quarantined-samples',
      data: labSampleId !== null ? { ...data, labSampleId } : data,
    });
  },
  patch(sampleId, data) {
    return http.request({
      method: 'patch',
      url: `/quarantined-samples/${sampleId}`,
      data,
    });
  },
  delete(id) {
    return http.request({
      method: 'delete',
      url: `/quarantined-samples/${id}`,
    });
  },
  autocompleteFetch(productName) {
    const filter = {
      where: {
        and: [
          {
            productName: { regexp: `/${productName}/i` },
          },
          {
            or: [{ status: LAB_SAMPLE_STATUSES.PENDING }],
          },
        ],
      },
      // Limit autocomplete results to prevent connection pool saturation
      // Autocomplete dropdowns don't need hundreds of results
      limit: 20,
    };
    return http.request({
      method: 'get',
      url: '/samples',
      params: { filter },
    });
  },
  accept(id, labSampleId) {
    return http.request({
      method: 'post',
      url: `/quarantined-samples/${id}/status`,
      data: {
        status: LAB_SAMPLE_STATUSES.ACCEPTED,
        labSampleId,
      },
    });
  },
  reject(id, labSampleId = null, rejectReason = '') {
    return http.request({
      method: 'post',
      url: `/quarantined-samples/${id}/status`,
      data: {
        status: LAB_SAMPLE_STATUSES.REJECTED,
        ...(labSampleId && { labSampleId }),
        ...(rejectReason && { rejectReason }),
      },
    });
  },
};

export default quarantine;
